import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>FreshFitLab</h3>
          <p>Discover and share amazing recipes, workouts, and more</p>
        </div>
        <div className="footer-section">
          <h3>Solutions</h3>
          <ul>
            <li><Link to="/meal-planning">Meal Planning</Link></li>
            <li><Link to="/fitness-training">Fitness Training</Link></li>
            <li><Link to="/coaching">Coaching</Link></li>
            <li><Link to="/for-business">For Business</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Explore</h3>
          <ul>
            <li><Link to="/menu">Recipes</Link></li>
            <li><Link to="/fitness/exercises">Exercise Library</Link></li>
            <li><Link to="/fitness/workouts">Workouts</Link></li>
            <li><Link to="/fitness">Programs</Link></li>
            <li><Link to="/coaches">Find a Coach</Link></li>
            <li><Link to="/creators">Recipe Creators</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
            <li><Link to="/pricing">Pricing</Link></li>
            <li><Link to="/affiliate/register">Become a Creator / Coach</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Legal</h3>
          <ul>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
            <li><Link to="/delete-account">Delete Account</Link></li>
          </ul>
        </div>
        <div className="footer-section footer-section-app">
          <h3>Get the App</h3>
          <a
            href="https://apps.apple.com/us/app/freshmenulab/id6758483247"
            className="footer-app-store-badge"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download FreshFitLab on the App Store"
          >
            <svg viewBox="0 0 384 512" width="18" height="18" fill="currentColor">
              <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
            </svg>
            <div className="footer-badge-text">
              <span className="footer-badge-small">Download on the</span>
              <span className="footer-badge-large">App Store</span>
            </div>
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.freshmenulab"
            className="footer-app-store-badge footer-google-play-badge"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get FreshFitLab on Google Play"
          >
            <svg viewBox="0 0 512 512" width="18" height="18" fill="currentColor">
              <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
            </svg>
            <div className="footer-badge-text">
              <span className="footer-badge-small">Get it on</span>
              <span className="footer-badge-large">Google Play</span>
            </div>
          </a>
          <p className="footer-contact">support@freshfitlab.io</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} FreshFitLab. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 